import React, { useState } from "react";
import CustomTextField from "../../../common/InputField/Input";
import { Switch } from "antd";
import { IoMdAdd } from "react-icons/io";
import { FaMinus } from "react-icons/fa";
import PartialPaymentBanner from "../../../../assets/images/svgs/PartialPaymentBanner.svg";
import { Autocomplete, Box, TextField } from "@mui/material";
import { currenciesInitials } from "../../../../utils/helper";
import { TranslateText } from "../../../../utils/translation";

const Index = ({ localHotelDetailsState, setLocalHotelDetailsState }) => {
  const [currencySearchString, setCurrencySearchString] = useState("");

  return (
    <div className="mb-[10rem]">
      <div className="flex justify-between items-center">
        <div
          className="w-[65%] font-body font-[400] text-[20px] leading-[30.24px] 
        text-fg"
        >
          <TranslateText textKey={"set_currency"} namespace="profile" />
        </div>

        <div className="w-[35%] ">
          <Autocomplete
            id="currency-select"
            sx={{
              width: "100%",
              "& label": {
                color: "rgb(var(--color-black) / 0.3)",
                fontFamily: "var(--font-body)",
                fontSize: "15px",
              },
              "& input": {
                fontFamily: "var(--font-body)",
                fontSize: "0.75rem",
                fontWeight: "400",
                color: "rgb(var(--color-text-secondary))",
              },
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
              },
              "& .MuiInputLabel-root": {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontFamily: "var(--font-body)",
                color: "rgb(var(--color-text-muted))",
                fontSize: "1rem", // Font size when label is down
                padding: "3px", // Add padding here
              },
              "& .MuiInputLabel-shrink": {
                fontSize: "0.93rem", // Font size when label is up (focused)
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontFamily: "var(--font-body)",
              },
            }}
            options={currenciesInitials}
            value={localHotelDetailsState?.currency}
            onChange={(event, newValue) =>
              setLocalHotelDetailsState({
                ...localHotelDetailsState,
                currency: newValue,
              })
            }
            inputValue={currencySearchString}
            onInputChange={(event, newInputValue) => {
              setCurrencySearchString(newInputValue);
            }}
            autoHighlight
            getOptionLabel={(option) => option}
            renderOption={(props, option) => (
              <Box
                sx={{
                  color: "rgb(var(--color-black) / 0.7)",
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "18px",
                  fontStyle: "var(--font-body)",
                }}
                component="li"
                {...props}
              >
                {option}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Currency"
                sx={{ borderRadius: 10, padding: "3px" }} // Add padding here
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "new-password", // disable autocomplete and autofill
                }}
                InputLabelProps={{
                  style: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  },
                }}
              />
            )}
          />
        </div>
      </div>

      <div className="w-[100%] border-[0.5px] border-neutral-200 my-[32px]" />

      <div className="flex justify-between items-center">
        <div
          className="w-[65%] font-body font-[400] text-[20px] leading-[30.24px] 
        text-fg"
        >
          <TranslateText
            textKey={"set_minimum_booking_amount"}
            namespace="profile"
          />
        </div>
        <div>
          <Switch
            checked={localHotelDetailsState?.partialPaymentAllowed}
            onChange={(checked) =>
              setLocalHotelDetailsState({
                ...localHotelDetailsState,
                partialPaymentAllowed: checked,
              })
            }
          />
        </div>
      </div>

      {localHotelDetailsState?.partialPaymentAllowed && (
        <div className="parentContainer flex justify-between items-center mt-[24px]">
          <div className="flex gap-[24px] items-center">
            <div className="flex gap-[12px] items-center">
              <div
                className="border-2 border-primary w-[20px] h-[20px] rounded-[50%] flex justify-center items-center cursor-pointer"
                onClick={() =>
                  setLocalHotelDetailsState({
                    ...localHotelDetailsState,
                    minBookingAmount: { title: "percentage", value: "" },
                  })
                }
              >
                {Boolean(
                  localHotelDetailsState?.minBookingAmount?.title ===
                  "percentage",
                ) && (
                  <div className="bg-primary rounded-[100%] w-[12px] h-[12px]"></div>
                )}
              </div>
              <div className="font-body font-[400] text-[16px] leading-[24px] tracking-[0.5px] text-fg-placeholder">
                <TranslateText
                  textKey={"percentage_of_total_booking"}
                  namespace="profile"
                />
              </div>
            </div>

            <div className="flex gap-[12px] items-center">
              <div
                className="border-2 border-primary w-[20px] h-[20px] rounded-[50%] flex justify-center items-center cursor-pointer"
                onClick={() =>
                  setLocalHotelDetailsState({
                    ...localHotelDetailsState,
                    minBookingAmount: { title: "amount", value: "" },
                  })
                }
              >
                {Boolean(
                  localHotelDetailsState?.minBookingAmount?.title === "amount",
                ) && (
                  <div className="bg-primary rounded-[100%] w-[12px] h-[12px]"></div>
                )}
              </div>
              <div className="font-body font-[400] text-[16px] leading-[24px] tracking-[0.5px] text-fg-placeholder">
                <TranslateText textKey={"fixed_amount"} namespace="profile" />
              </div>
            </div>
          </div>

          <div className="w-[40%]">
            <CustomTextField
              placeholder={`${
                localHotelDetailsState?.minBookingAmount?.title === "amount"
                  ? "Enter amount"
                  : " Enter percentage"
              }`}
              label=""
              isManadatory={true}
              value={localHotelDetailsState?.minBookingAmount?.value}
              onChange={(value) =>
                setLocalHotelDetailsState({
                  ...localHotelDetailsState,
                  minBookingAmount: {
                    ...localHotelDetailsState?.minBookingAmount,
                    value: value,
                  },
                })
              }
              type="number"
              inputPadding={true}
              inputPaddingValue="8px"
              labelFontSize="14px"
            />
          </div>
        </div>
      )}

      <div className="w-[100%] border-[0.5px] border-neutral-200 my-[32px]" />

      <div className="flex justify-between items-center mb-[24px]">
        <div
          className="w-[85%] font-body font-[400] text-[20px] leading-[30.24px] 
        text-fg"
        >
          <TranslateText
            textKey={"remaining_amount_needs_to_be_collected_before"}
            namespace="profile"
          />{" "}
          <span className="whitespace-nowrap">
            <TranslateText textKey={"check_in"} namespace="profile" />
          </span>
        </div>
        <div>
          <Switch
            checked={
              localHotelDetailsState?.remainingAmountToBeCollectedBeforeCheckIn
            }
            onChange={(checked) =>
              setLocalHotelDetailsState({
                ...localHotelDetailsState,
                remainingAmountToBeCollectedBeforeCheckIn: checked,
              })
            }
          />
        </div>
      </div>

      {localHotelDetailsState?.remainingAmountToBeCollectedBeforeCheckIn && (
        <div className="w-[40%]">
          {" "}
          <CustomTextField
            placeholder="No of days before check-in"
            isManadatory={false}
            value={localHotelDetailsState?.noOfDaysBeforeCheckIn}
            onChange={(value) =>
              setLocalHotelDetailsState({
                ...localHotelDetailsState,
                noOfDaysBeforeCheckIn: value,
              })
            }
            type="text"
            inputPadding={true}
            inputPaddingValue="8px"
            labelFontSize="14px"
          />
        </div>
      )}

      <div className="w-[100%] border-[0.5px] border-neutral-200 my-[32px]" />

      <div className="flex justify-between items-center mb-[24px]">
        <div
          className="w-[85%] font-body font-[400] text-[20px] leading-[30.24px] 
  text-fg"
        >
          <TranslateText
            textKey={"isDisabledPaymentGateway"}
            namespace="profile"
          />{" "}
        </div>
        <div>
          <Switch
            checked={localHotelDetailsState?.disablePaymentGateway || false}
            onChange={(checked) =>
              setLocalHotelDetailsState({
                ...localHotelDetailsState,
                disablePaymentGateway: checked,
              })
            }
          />
        </div>
      </div>

      <div className="w-[100%] border-[0.5px] border-neutral-200 my-[32px]" />

      <div className="flex justify-between items-center">
        <div
          className="w-[65%] font-body font-[400] text-[20px] leading-[30.24px] 
        text-fg"
        >
          <TranslateText
            textKey={"non_refundable_partial_payment"}
            namespace="profile"
          />
        </div>
        <div>
          <Switch
            checked={localHotelDetailsState?.nonRefundablePartialPaymentAllowed}
            onChange={(checked) =>
              setLocalHotelDetailsState({
                ...localHotelDetailsState,
                nonRefundablePartialPaymentAllowed: checked,
              })
            }
          />
        </div>
      </div>

      <div className="mt-[34px]">
        <img src={PartialPaymentBanner} alt="" />
      </div>

      <div className="w-[100%] border-[0.5px] border-neutral-200 my-[32px]" />

      <div className="font-body font-[500] text-[24px] leading-[30.24px] text-fg flex flex-col gap-[24px]">
        <div className="font-body font-[500] text-[20px] leading-[30.24px] text-fg">
          <TranslateText textKey={"tax_setting"} namespace="profile" />
        </div>
        <div className="font-body font-[400] text-[18px] leading-[28px] text-fg">
          <TranslateText
            textKey={
              "do_you_want_to_set_your_price_with_included_tax_or_excluded_tax"
            }
            namespace="profile"
          />
        </div>
        <div className="flex gap-[24px] items-center">
          <div className="flex gap-[12px] items-center ">
            <div
              className="border-[2px] border-primary w-[20px] h-[20px] flex justify-center items-center rounded-[50%] cursor-pointer"
              onClick={() =>
                setLocalHotelDetailsState({
                  ...localHotelDetailsState,
                  taxIncludedInPrice: true,
                })
              }
            >
              {Boolean(localHotelDetailsState?.taxIncludedInPrice) && (
                <div className="bg-primary rounded-[100%] w-[12px] h-[12px]"></div>
              )}
            </div>
            <div className="font-body font-[400] text-[16px] leading-[24px] tracking-[0.5px] text-fg-placeholder">
              <TranslateText textKey={"tax_included"} namespace="profile" />
            </div>
          </div>

          <div className="flex gap-[12px] items-center ">
            <div
              className="border-[2px] border-primary w-[20px] h-[20px] rounded-[50%] flex justify-center items-center cursor-pointer"
              onClick={() =>
                setLocalHotelDetailsState({
                  ...localHotelDetailsState,
                  taxIncludedInPrice: false,
                })
              }
            >
              {!Boolean(localHotelDetailsState?.taxIncludedInPrice) && (
                <div className="bg-primary rounded-[100%] w-[12px] h-[12px]"></div>
              )}
            </div>
            <div className="font-body font-[400] text-[16px] leading-[24px] tracking-[0.5px] text-fg-placeholder">
              <TranslateText textKey={"tax_excluded"} namespace="profile" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
